import React from 'react';
import { ListGroup } from 'react-bootstrap';
import {
  DndContext,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical } from '@fortawesome/free-solid-svg-icons';

// Funzione helper per spostare elementi in un array
const arrayMove = (array, from, to) => {
    const newArray = [...array];
    const [item] = newArray.splice(from, 1);
    newArray.splice(to, 0, item);
    return newArray;
};

// Componente per il singolo item trascinabile
function SortableColumnItem({ id, label }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.8 : 1,
    zIndex: isDragging ? 10 : 'auto',
    cursor: 'grab',
  };

  return (
    <ListGroup.Item ref={setNodeRef} style={style} {...attributes} {...listeners} className="p-1 d-flex align-items-center">
      <FontAwesomeIcon icon={faGripVertical} className="me-2 text-muted" />
      {label}
    </ListGroup.Item>
  );
}

// Componente principale
function ColumnOrderController({ table, allColumnsMap }) {
  const { getState, setColumnOrder } = table;
  const { columnOrder } = getState();

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = columnOrder.indexOf(active.id);
      const newIndex = columnOrder.indexOf(over.id);
      
      // Funzione arrayMove definita globalmente
      setColumnOrder(arrayMove(columnOrder, oldIndex, newIndex));
    }
  };

  // Filtra le colonne per mostrare solo quelle ordinabili, escludendo 'select'
  const orderedVisibleColumns = columnOrder
    .map(id => table.getColumn(id)) // Ottieni l'oggetto colonna
    .filter(col => col && col.id !== 'select' && col.getIsVisible()) // Filtra per quelle visibili e non nullo
    .map(col => ({ id: col.id, label: allColumnsMap[col.id] }));


  return (
    <div className="p-2">
      <h6 className="fw-bold">Ordine Colonne</h6>
      <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
        <SortableContext items={orderedVisibleColumns.map(c => c.id)} strategy={verticalListSortingStrategy}>
          <ListGroup variant="flush">
            {orderedVisibleColumns.map(({ id, label }) => (
              <SortableColumnItem key={id} id={id} label={label} />
            ))}
          </ListGroup>
        </SortableContext>
      </DndContext>
    </div>
  );
}

export default ColumnOrderController;
